import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eed09068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-panel-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }),
  /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, "欢迎登录共享平台")
], -1))
const _hoisted_3 = { class: "login-panel-main" }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-field-t" }, "账号", -1))
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-field-t" }, "密码", -1))
const _hoisted_8 = { class: "checkbox" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("记住")
const _hoisted_10 = { class: "btn" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("登录中...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_form, {
        ref: "loginform",
        onSubmit: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_van_field, {
              modelValue: _ctx.userData.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userData.username) = $event)),
              modelModifiers: { trim: true },
              placeholder: "请输入您的账号",
              rules: [{ required: true, message: '请输入您的账号' }],
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_van_field, {
              modelValue: _ctx.userData.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userData.password) = $event)),
              modelModifiers: { trim: true },
              type: _ctx.isShow ? 'text' : 'password',
              placeholder: "请输入您的密码",
              rules: [{ required: true, message: '请输入您的密码' }],
              clearable: ""
            }, {
              "right-icon": _withCtx(() => [
                _createVNode(_component_van_icon, {
                  name: _ctx.isShow ? 'eye-o' : 'closed-eye',
                  onClick: _ctx.fClickShow,
                  style: {"margin-left":"10px"}
                }, null, 8, ["name", "onClick"])
              ]),
              _: 1
            }, 8, ["modelValue", "type"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_checkbox, {
              modelValue: _ctx.isReadme,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isReadme) = $event)),
              shape: "square",
              "icon-size": "16px"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createVNode(_component_van_loading, {
              type: "spinner",
              color: "#fff",
              size: "20px"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.loading]
            ]),
            _withDirectives(_createElementVNode("span", {
              style: {"display":"inline-block","width":"100%","height":"100%"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fSubmit && _ctx.fSubmit(...args)))
            }, "登录", 512), [
              [_vShow, !_ctx.loading]
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}